export default "__VITE_ASSET__cf9e4bbc__"